// @core/api/endpoints/booking/delete_booking_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/booking';

/**
 * Delete booking type
 * Deactivates a booking type. Existing resources and bookings of this type are not affected.
 */
export async function DeleteBookingType(
  type_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
